const mapAddonProductsToDomains = (products) => {
  const addonProducts = [];

  if (!products) {
    return addonProducts;
  }

  for (const product of products) {
    for (const line of product.lines) {
      if (line.addOnProductType) {
        // We have an addon product
        const { addOnProductType } = line;

        // Check if we have already seen the addonProduct
        const existingAddonProduct = addonProducts.find(
          (element) => addOnProductType === element.name,
        );

        if (existingAddonProduct) {
          // Add the domain to the addon product
          existingAddonProduct.domains.push(product.fullDomain);
          continue;
        }

        // We don't have the addon product
        addonProducts.push({
          name: addOnProductType,
          domains: [product.fullDomain],
        });
      }
    }
  }

  return addonProducts;
};

export default mapAddonProductsToDomains;
